// extracted by mini-css-extract-plugin
export var brand = "_af-9";
export var compact = "_af-6";
export var extraSmall = "_af-7";
export var icon = "_af-0";
export var large = "_af-4";
export var light = "_af-1";
export var medium = "_af-5";
export var outline = "_af-b";
export var primaryDark = "_af-a";
export var primaryLight = "_af-8";
export var primaryModern = "_af-c";
export var success = "_af-2";
export var successSolid = "_af-3";